export interface FocusArea {
  title: string
  description: string
  tags: string[]
}

export const FOCUS_AREAS: FocusArea[] = [
  {
    title: 'Platform Engineering',
    description:
      'Internal developer platforms, self-service workflows, and standardized environments that let developers ship without wrestling infrastructure.',
    tags: ['Backstage', 'Crossplane', 'Karpenter', 'vCluster'],
  },
  {
    title: 'Cloud Infrastructure',
    description:
      'AWS, Azure and Kubernetes infrastructure designed, provisioned and operated as code.',
    tags: ['AWS', 'EKS', 'Azure', 'AKS', 'Terraform', 'Ansible'],
  },
  {
    title: 'DevOps & GitOps',
    description:
      'Automated delivery pipelines and GitOps workflows where the repository is the single source of truth for what runs in production.',
    tags: ['GitHub Actions', 'GitLab CI', 'Argo CD', 'Helm'],
  },
  {
    title: 'DevSecOps',
    description:
      'Secrets management, federated identity, policy enforcement and supply-chain security embedded into the platform instead of bolted on.',
    tags: ['Vault', 'OIDC', 'Kyverno', 'Trivy', 'Cosign', 'Falco', 'Istio'],
  },
  {
    title: 'Observability',
    description:
      'Metrics, logs and traces wired end to end so the platform can be understood, debugged and improved in production.',
    tags: ['Prometheus', 'Grafana', 'Loki', 'Tempo', 'OpenTelemetry', 'ELK'],
  },
]